import React from 'react';
import { View, Text, Image } from 'react-native';

import { hp, wp } from 'utils/normalise';
import VText from 'components/VText';
import { TouchableOpacity } from 'react-native';
import Button from 'components/Buttons';

const EmptyScreen = ({
    icon,
    title,
    description,
    buttonText,
    onPress,
}) => {
    
        return (
            <View style={{ flex: 1, alignItems: 'center', justifyContent: 'center', marginTop: hp(20) }}>
                <Image accessibilityLabel={`${title} Icon`} source={icon} />
                {title && <VText style={{ fontSize: 20, fontWeight: 'bold', marginTop: hp(14) }}>{title}</VText>}
                {description && <VText style={{ fontSize: 16,fontWeight: '350', marginTop: hp(12),width: wp(230), textAlign: 'center' }}>{description}</VText>}
                {buttonText && 
                    <TouchableOpacity style={{ marginTop: hp(12) }} onPress={onPress}>
                        <Button onPress={onPress} textStyle={{ fontSize: 16, fontWeight: '600' }} containerStyle={{ width: wp(210) }} text={buttonText} />
                    </TouchableOpacity>
                }
            </View>
        );

};

export default EmptyScreen;